export const RESTRICTED_PROJECTS_REDUCER_KEYS = {
  BY_PROJECT_ID: 'byProjectId',
  LOADING_STATES: 'loadingStates',
  ERROR_STATES: 'errorStates',
}